import { defineMeta } from '@/registry/types';

export const buttonGroupMeta = defineMeta({
  name: 'ButtonGroup',
  level: 'molecule',
  category: 'input',
  classification: 'themed-mui',
  description: 'Groups related buttons into a single visual unit. Themed MUI ButtonGroup.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'ButtonGroup',
  muiDocs: 'https://mui.com/material-ui/react-button-group/',
  a2uiEquivalent: 'ButtonGroup',
  importPath: '@/molecules/ButtonGroup',
  optionalProps: ['variant', 'orientation', 'size', 'disabled'],
  supportedStates: ['default', 'disabled'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Each button remains independently focusable.'],
  usageExamples: ['<ButtonGroup><Button>Day</Button><Button>Week</Button></ButtonGroup>'],
  antiPatterns: ['Do not use for mutually-exclusive selection (use ToggleButtonGroup).'],
  llmSafe: true,
  whenToUse: ['Related action clusters'],
  whenNotToUse: ['Single selection toggles'],
});

export default buttonGroupMeta;
